import { analyticsManager } from "@/services/analytics/analytics-manager";

export const track = {
  mounted(el, binding) {
    const handler = () => {
      analyticsManager.trackClick(binding);
    };
    el._trackHandler = handler;
    el.addEventListener("click", handler, { capture: true });
  },

  updated(el, binding) {
    if (!el._trackHandler) {
      return;
    }
    el.removeEventListener("click", el._trackHandler, { capture: true });
    const handler = () => {
      analyticsManager.trackClick(binding);
    };
    el._trackHandler = handler;
    el.addEventListener("click", handler, { capture: true });
  },

  unmounted(el) {
    if (el._trackHandler) {
      el.removeEventListener("click", el._trackHandler, { capture: true });
      delete el._trackHandler;
    }
  },
};
